const translations = {
    duplicateError: 'This certification already exists.',
    memberConflictError:
        'This certification was not saved because this user belongs to more than one organization.',
    save: 'Save Certification',
    saveError: 'Something went wrong. Please try again.',
    title: 'Add Applicator Certification'
};

export default translations;
